import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { VertNavButtonGroup } from '../vertical_icon_bar/vertical_icon_bar.styles';
export const TopNav = props => {
    const { children } = props;
    return _jsx(VertNavButtonGroup, { children: children });
};
//# sourceMappingURL=top_nav.js.map